import { useState, useEffect } from "react";
import { Box, Modal, IconButton } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import CloseIcon from "@mui/icons-material/Close";
import { styles } from "./stylesImagePreviewModal";

interface ImagePreviewModalProps {
  images: string[];
  open: boolean;
  onClose: () => void;
  initialIndex?: number;
}

const ImagePreviewModal = ({ images, open, onClose, initialIndex = 0 }: ImagePreviewModalProps) => {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);

  useEffect(() => {
    if (open) {
      setCurrentIndex(initialIndex);
    }
  }, [initialIndex, open]);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box sx={styles.modalContainer}>
        <IconButton onClick={onClose} sx={styles.closeButton}>
          <CloseIcon fontSize="large" />
        </IconButton>

        {images.length > 1 && (
          <>
            <IconButton
              onClick={handlePrev}
              sx={{
                ...styles.navButton,
                ...(styles.prevButton as any),
              }}
            >
              <ArrowBackIosNewIcon />
            </IconButton>

            <IconButton
              onClick={handleNext}
              sx={{
                ...styles.navButton,
                ...(styles.nextButton as any),
              }}
            >
              <ArrowForwardIosIcon />
            </IconButton>

            <Box sx={styles.counter}>
              {currentIndex + 1} / {images.length}
            </Box>
          </>
        )}

        <Box
          component="img"
          src={images[currentIndex]}
          alt={`preview-${currentIndex}`}
          sx={styles.image}
        />
      </Box>
    </Modal>
  );
};

export default ImagePreviewModal;
